export function getMarkdownValue(field: any): string {
  if (!field) return '';
  // For nested structure: { data: { copyright: "..." } }
  if (field.data && typeof field.data === 'object') {
    const nestedValue = Object.values(field.data)[0];
    if (typeof nestedValue === 'string') return nestedValue;
  }
  if (typeof field === 'string') return field;
  return '';
}
